import useAuthMiddleware from "../../../middlewares/AuthMiddleware";
import useRouteValidator from "../RouteValidator";
import useMiddlewares from "../../../middlewares/Middleware";
import useCompanyTypeMiddleware from "../../../middlewares/CompanyTypeMiddleware";
import useRoleTypeMiddleware from "../../../middlewares/RoleTypeMiddleware";
import usePermissionMiddleware from "../../../middlewares/PermissionMiddleware";

/**
 * @returns {{ validate: () => boolean|{ to: string, replace: boolean }}}
 */
export function useButtonsRouteValidator() {
  return useRouteValidator(
    useMiddlewares([
      useAuthMiddleware(),
      useCompanyTypeMiddleware(["default", "business_center"]),
      useRoleTypeMiddleware(["superadmin", "user"]),
      usePermissionMiddleware(["buttons.read", "buttons.read.screen"]),
    ])
  );
}
